import { previewViewModes } from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/constants'
import {
  getBlockDefinition,
  getBlockSettings,
} from '@/configuration/pages/ConfigurationPage/OrderTrackingPageConfiguration/helpers'

import { compareLayoutItems } from '../useTrackingPageLayout/helpers'

const normalizeLayout = layout => {
  const sortedItems = [...layout].sort(compareLayoutItems)

  return sortedItems.map((item, index) => ({ ...item, y: index }))
}

export const normalizeLayouts = layouts => {
  return {
    [previewViewModes.desktop]: normalizeLayout(layouts[previewViewModes.desktop]),
    [previewViewModes.mobile]: normalizeLayout(layouts[previewViewModes.mobile]),
  }
}

const attachBlockSettingsToLayout = (layout, blockSettings) => {
  return layout.map(item => {
    return { ...item, settings: getBlockSettings(getBlockDefinition(item.i), blockSettings[item.i]) }
  })
}

export const attachBlockSettings = (layouts, blockSettings) => {
  return {
    [previewViewModes.desktop]: attachBlockSettingsToLayout(layouts[previewViewModes.desktop], blockSettings),
    [previewViewModes.mobile]: attachBlockSettingsToLayout(layouts[previewViewModes.mobile], blockSettings),
  }
}
